// Packages
import { useState } from 'react';

// main components below
import DoctorTable from './components/Table';
import DoctorFilter from './components/Filter';
import ViewDoctorProfile from 'pages/Doctors/ViewProfile';

// Nursing Components
import ModalNote from './components/Note';
import ModalAddDiagnosis from 'pages/Nursing/components/Diagnosis/AddDiagnosis';
import ModalLabRequest from 'pages/Nursing/components/SearchPatient/PatientWorklist/LabRequest';
import ModalProcedure from 'pages/Nursing/components/SearchPatient/PatientWorklist/Procedure';
import ModalMedication from 'pages/Nursing/components/SearchPatient/PatientWorklist/Medication';

// main component
const SearchPatient = () => {
  const [state, setState] = useState([]);
  const [showProfile, setShowProfile] = useState({
    note: false,
    supply: false,
    profileId: null,
    addOrder: false,
    procedure: false,
    medication: false,
    labRequest: false,
    isShowProfile: false,
  });

  return (
    <>
      <div className='searchPatient'>
        {!showProfile.isShowProfile ? (
          <>
            <DoctorFilter state={state} setState={setState} />

            <DoctorTable state={state} setState={setState} setShowProfile={setShowProfile} />
          </>
        ) : (
          <ViewDoctorProfile setShowProfile={setShowProfile} showProfile={showProfile} />
        )}
      </div>

      <ModalNote setShowProfile={setShowProfile} showProfile={showProfile} />
      <ModalProcedure setShowProfile={setShowProfile} showProfile={showProfile} />
      <ModalLabRequest setShowProfile={setShowProfile} showProfile={showProfile} />
      <ModalMedication setShowProfile={setShowProfile} showProfile={showProfile} />
      <ModalAddDiagnosis setShowProfile={setShowProfile} showProfile={showProfile} />
    </>
  );
};

export default SearchPatient;
